// extracted by mini-css-extract-plugin
module.exports = {"cell":"_f2a2957","cellExpand":"_c9362a2"};